/*const firstSelect = document.querySelector('.single-option-selector');
const secondSelect = document.querySelector('select[name="id"]');
if(firstSelect){ 
firstSelect.addEventListener('change', function() {
  const selectedOption = this.value; 
  for (let option of secondSelect.options) {
    if (option.textContent.trim() === selectedOption) {
      var variantInput = option.value;
      loadHwsPlans(variantInput);
      break;
    } 
  } 
  console.log(secondSelect.value);
});
}*/ 


document.body.addEventListener('change', function(event) {
  if (event.target && event.target.id === 'variantSelect') {
    var variantSelect = event.target;
    if (variantSelect && variantSelect.options.length > 0) {
      var value = variantSelect.value;
    
      loadHwsPlans(value);
    }
  }
});
document.addEventListener('DOMContentLoaded', async () => {
    var variantInput = await getVariantParamValue();
    console.log(variantInput);
    loadHwsPlans(variantInput);
});
document.addEventListener('DOMContentLoaded', async () => {
    const variantInput = await getVariantParamValue();
  setTimeout(function() {
  
  const hiddenSelect = document.querySelector('#hidden-variant-select');
  if (!hiddenSelect) return;
  const matchedHiddenOption = Array.from(hiddenSelect.options).find(
    opt => opt.dataset.id === String(variantInput)
  );
  if (!matchedHiddenOption) {
    console.log('❌ No matching variant found in hidden select');
    return;
  }
  const isAvailable = String(matchedHiddenOption.dataset.available) === 'true';
  const checkoutText = document.querySelector('.hwsubsCheckouttext');
  const checkoutBtn = document.querySelector('#hwsubsCheckout');
  const subsPrice = document.querySelector('#Hw-GetSubsPrice');
  if (!isAvailable) {
    console.log(isAvailable ? 'Available ✅' : 'Sold Out ❌');
    if (checkoutText) checkoutText.textContent = 'Sold Out';
    if (checkoutBtn) checkoutBtn.disabled = true;
    if (subsPrice) subsPrice.style.display = 'none';
  }
  }, 500);
});
async function getVariantParamValue() { 
  const url = new URL(window.location.href);
 
  // ✅ Case 1: Variant exists in query param
  if (url.searchParams.has('variant')) {
    return url.searchParams.get('variant');
  }

  // ✅ Case 2: No variant → fetch product JSON by handle
  try {
    // Extract handle from URL (/products/handle)
    let pathParts = window.location.pathname.split("/");
    let handleIndex = pathParts.indexOf("products");
    if (handleIndex === -1 || !pathParts[handleIndex + 1]) return null;

    let productHandle = pathParts[handleIndex + 1];

    let res = await fetch(`/products/${productHandle}.js`);
  console.log(res);
    if (!res.ok) throw new Error("Product fetch failed");

    let product = await res.json();
    if (product.variants && product.variants.length > 0) {
      return product.variants[0].id; // 👈 First variant ID
    }
  } catch (err) {
    console.error("Error fetching first variant:", err);
  }

  return null;
}
var domainName = Shopify.shop;
var productId = '';
var productIdElement = document.querySelector('input[name="product-id"]');
if (productIdElement) {
  productId = productIdElement.value;
}

var scriptTag1 = document.getElementById('shopify-features');
if (scriptTag1) {
  var shopifyFeatures = JSON.parse(scriptTag1.textContent);
  //domainName = shopifyFeatures.domain;
}

document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".quick_shop").forEach(button => {
        button.addEventListener("click", function () {
            let quickproductId = this.getAttribute("data-id");
            let quickdomainName = Shopify.shop;
          console.log(quickproductId);
          console.log(quickdomainName);
            QuickloadHwsPlans(quickproductId, quickdomainName);
        });
    });
});

    function QuickloadHwsPlans(quickproductId,quickdomainName){
    
      if(quickdomainName != "" && quickproductId != ""){
       
        var data = {
            myshopifyDomain: btoa(quickdomainName),
            product: btoa(quickproductId)
          };
        var jsonString = JSON.stringify(data);
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: jsonString,
          redirect: "follow"
        };

  
        fetch(`https://subscriptions.gosimple.app/api/plans`, requestOptions)
          .then((response) => response.json())
          .then((result) => {
              if (result.returnhtml) {
                if(result.returnhtml != ''){
                  var forms = document.querySelectorAll('form[action="/cart/add"]');
                  forms.forEach(function(form) {
                    form.style.display = 'none';
                  });
                }

                
          
                var productprice = document.querySelector('.price');
                if (productprice) {
                  productprice.style.display = 'none';
                }
          
                var variantSelects = document.querySelector('variant-selects');
                if (variantSelects) {
                  variantSelects.style.display = 'none';
                }
          
                var quantityInput = document.querySelector('quantity-input');
                if (quantityInput) {
                  quantityInput.style.display = 'none';
                  var closestLabel = quantityInput.previousElementSibling;
                  if (closestLabel && closestLabel.tagName.toLowerCase() === 'label') {
                    closestLabel.style.display = 'none';
                  }
                }
          
                let hwsInsertDiv = document.querySelector('#Hwsinsertlists');
                if (hwsInsertDiv) {
                  hwsInsertDiv.innerHTML = result.returnhtml;
                  appendAjaxResponseToDOM1(result.paystrackjs);
                }

                document.querySelectorAll(".batchblocks").forEach(el => {
                                el.style.display = "block";
                            });
    
              }
          })
          .catch((error) => {
              console.error("Error:", error);
          });

      }
    }

    function getAssetUrl(fileName) {
        if (!window.hwsAssetDummy) {
            throw new Error("hwsAssetDummy not defined. Add it in theme.liquid.");
        }
        return window.hwsAssetDummy.replace("dummy.json", fileName);
    }

    var hwsPlanJsonCache = Object.create(null);

    function hwsSetCheckoutPriceReady(isReady) {
        if (!document.getElementById("hws-price-pending-style")) {
            var styleEl = document.createElement("style");
            styleEl.id = "hws-price-pending-style";
            styleEl.textContent = ".hwsubsCheckouttext.hws-price-pending{opacity:.5}.hws-price-pending#hwsubsCheckout{pointer-events:none;opacity:.7}";
            document.head.appendChild(styleEl);
        }
        var checkoutBtn = document.querySelector("#hwsubsCheckout");
        var checkoutText = document.querySelector(".hwsubsCheckouttext");
        if (checkoutBtn) checkoutBtn.classList.toggle("hws-price-pending", !isReady);
        if (checkoutText) checkoutText.classList.toggle("hws-price-pending", !isReady);
    }

    function hwsGetCheckoutSpinnerEl() {
        var btn = document.getElementById("hwsubsCheckout");
        if (!btn) return null;
        return btn.querySelector("svg.icon-spinner, svg.spinner, svg[aria-hidden='true']");
    }

    function hwsClearCheckoutSpinner() {
        var spinner = hwsGetCheckoutSpinnerEl();
        if (!spinner) return;
        spinner.innerHTML = "";
        spinner.style.display = "none";
    }

    function hwsApplyInitialPlanSelection(postselctedtype) {
        document.querySelectorAll(".batchblocks").forEach(function (el) {
            el.style.display = "block";
        });

        function activateToggle(dataId) {
            var scope = hwsGetActiveBatchScope();
            var toggleInput = scope.querySelector('input.subsoptionsforsel[data-id="' + dataId + '"]')
                || document.querySelector('input.subsoptionsforsel[data-id="' + dataId + '"]');
            if (!toggleInput) return false;
            toggleInput.checked = true;
            toggleInput.dispatchEvent(new Event("change", { bubbles: true }));
            return true;
        }

        function activateClickTarget(selector) {
            var scope = hwsGetActiveBatchScope();
            var clickTarget = scope.querySelector(selector) || document.querySelector(selector);
            if (!clickTarget) return false;
            clickTarget.click();
            hwsSyncPriceFromWidget();
            return true;
        }

        // Variant change: preserve the purchase type the shopper already chose
        if (postselctedtype === "onetime") {
            if (activateToggle("onetime") || activateClickTarget(".clickbyonetime")) return;
        } else if (postselctedtype === "subscription") {
            if (activateToggle("subscription") || activateClickTarget(".clickbydefault")) return;
        }

        // Initial load: respect widget_default_setting (.clickbydefault on server HTML)
        var scope = hwsGetActiveBatchScope();
        var serverDefault = scope.querySelector(".clickbydefault") || document.querySelector(".clickbydefault");
        if (serverDefault) {
            serverDefault.click();
            hwsSyncPriceFromWidget();
            return;
        }

        var alreadyChecked = document.querySelector(".subsoptionsforsel:checked");
        if (alreadyChecked) {
            hwsSyncPriceFromWidget();
            return;
        }

        activateToggle("subscription") || activateClickTarget(".clickbydefault");
    }

    function hwsSyncPriceFromWidget() {
        var checked = document.querySelector(".subsoptionsforsel:checked");
        if (checked && typeof window.__hwsHandleSubscriptionSelection === "function") {
            window.__hwsHandleSubscriptionSelection({ target: checked });
        }
    }

    function hwsGetActiveBatchScope(planId) {
        if (planId) {
            var byPlan = document.querySelector(".batchID-" + planId);
            if (byPlan) return byPlan;
        }
        var checked = document.querySelector(".subsoptionsforsel:checked");
        if (checked) {
            var fromRadio = checked.closest(".batchblocks, .hw-w-subcription-widget-box, .batchID-" + (checked.getAttribute("data-plan-id") || ""));
            if (fromRadio) return fromRadio;
        }
        var visibleBatch = document.querySelector(".batchblocks.batchID-" + (document.getElementById("planvariantSelect")?.value || ""));
        return visibleBatch || document;
    }

    function hwsParseUnitPrice(text) {
        return parseFloat(String(text || "").replace(/[^\d.]/g, "")) || 0;
    }

    function hwsReadPriceText(selectors, scope) {
        var root = scope || document;
        var list = Array.isArray(selectors) ? selectors : [selectors];
        for (var i = 0; i < list.length; i++) {
            var el = root.querySelector(list[i]) || document.querySelector(list[i]);
            if (el && el.textContent && el.textContent.trim()) {
                return el.textContent.trim();
            }
        }
        return "";
    }

    function hwsPriceLabelPrefix(labelEl, fallback) {
        if (!labelEl) return fallback;
        var raw = labelEl.textContent || "";
        var idx = raw.indexOf("|");
        return (idx >= 0 ? raw.slice(0, idx) : raw).trim() || fallback;
    }

    function hwsUpdateWidgetPriceLabels(scope, opts) {
        if (!scope) return;
        var qty = parseInt(opts.qty, 10) || 1;
        var currencySymbol = opts.currencySymbol || "";

        scope.querySelectorAll(".hw-w-subscription-box .hw-w-price-label").forEach(function (label) {
            var prefix = hwsPriceLabelPrefix(label, "Subscribe");
            var staticTxt = label.querySelector(".hw-simple-new-static-txt");
            var suffix = staticTxt ? " " + staticTxt.outerHTML : "";
            var total = (opts.subsalepriceNum * qty).toFixed(2);
            label.innerHTML = prefix + " | " + currencySymbol + total + suffix;
        });

        scope.querySelectorAll(".hw-w-one-time-box .hw-w-price-label").forEach(function (label) {
            var prefix = hwsPriceLabelPrefix(label, "One-time purchase");
            var staticTxt = label.querySelector(".hw-simple-new-static-txt");
            var suffix = staticTxt ? " " + staticTxt.outerHTML : "";
            var total = (opts.actualNum * qty).toFixed(2);
            label.innerHTML = prefix + " | " + currencySymbol + total + suffix;
        });
    }

    function hwsRenderPlansFromResult(result, qty, postselctedtype) {
        if (!result || !result.returnhtml) return;

        hwsSetCheckoutPriceReady(false);

        if (result.returnhtml !== "") {
            document.querySelectorAll('form[action="/cart/add"]').forEach(function (form) {
                form.style.display = "none";
            });
        }

        var variantSelects = document.querySelector("variant-selects");
        if (variantSelects) variantSelects.style.display = "none";

        var variantpurchase = document.querySelector(".purchase-tabs");
        if (variantpurchase) variantpurchase.style.display = "none";

        var productpc = document.querySelector(".product-price-container");
        if (productpc) productpc.style.display = "none";

        var quantityInput = document.querySelector("quantity-selector");
        if (quantityInput) {
            quantityInput.style.display = "none";
            var closestLabel = quantityInput.previousElementSibling;
            if (closestLabel && closestLabel.tagName.toLowerCase() === "label") {
                closestLabel.style.display = "none";
            }
        }

        var hwsInsertDiv = document.querySelector("#Hwsinsertlists");
        if (hwsInsertDiv) {
            hwsInsertDiv.innerHTML = result.returnhtml;
            appendAjaxResponseToDOM1(result.paystrackjs);
        }

        if (qty) {
            var inputField = document.querySelector(".Hw-subs-qty-input");
            if (inputField) inputField.value = qty;
        }

        initSubscriptionJS();
        hwsClearCheckoutSpinner();
        hwsApplyInitialPlanSelection(postselctedtype);
        hwsSyncPriceFromWidget();
        hwsSetCheckoutPriceReady(true);

        var subbutton = document.querySelector("#hwsubsCheckout");
        if (subbutton) {
            subbutton.disabled = false;
            subbutton.style.opacity = "1";
        }
    }

    function loadHwsPlans(variantInput, qty = null, postselctedtype = null) {
        if (!productId) {
            let quickshopInput = document.querySelector("#quickshop input[name='product-id']");
            if (quickshopInput) {
            productId = quickshopInput.value; // Get product ID from input field
            }
        }

        if (domainName !== "" && productId !== "") {
            let fileName = productId;
            if (variantInput) {
            fileName += "_" + variantInput;
            }
            fileName += ".json";

            let fileUrl = getAssetUrl(fileName);
            console.log("Fetching:", fileUrl);

            if (hwsPlanJsonCache[fileUrl]) {
                hwsRenderPlansFromResult(hwsPlanJsonCache[fileUrl], qty, postselctedtype);
                return;
            }

            hwsSetCheckoutPriceReady(false);

            fetch(fileUrl)
            .then((response) => {
                if (!response.ok) {
                throw new Error("Asset not found: " + fileUrl);
                }
                return response.json();
            })
            .then((result) => {
                hwsPlanJsonCache[fileUrl] = result;
                hwsRenderPlansFromResult(result, qty, postselctedtype);
            })
            .catch((error) => {
                console.error("Error:", error);
                hwsSetCheckoutPriceReady(true);
            });
        }
    }

    /*function loadHwsPlans(variantInput, qty = null, postselctedtype = null){

      if (!productId) {
          let quickshopInput = document.querySelector("#quickshop input[name='product-id']");
          if (quickshopInput) {
              productId = quickshopInput.value; // Get product ID from input field
          }
      }
      
      if(domainName != "" && productId != ""){
        
        if (variantInput) {
          var data = {
            myshopifyDomain: btoa(domainName),
            product: btoa(productId),
            variantInput: btoa(variantInput)
          };
        }else{
          var data = {
            myshopifyDomain: btoa(domainName),
            product: btoa(productId)
          };
        }
        var jsonString = JSON.stringify(data);
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: jsonString,
          redirect: "follow"
        };

        console.log('requestOptions',requestOptions);
  
        fetch(`https://subscriptions.gosimple.app/api/plans`, requestOptions)
          .then((response) => response.json())
          .then((result) => {
              if (result.returnhtml) {
                if(result.returnhtml != ''){
                  var forms = document.querySelectorAll('form[action="/cart/add"]');
                  forms.forEach(function(form) {
                    form.style.display = 'none';
                  });
                }
                
                var productprice = document.querySelector('.price');
                if (productprice) {
                  productprice.style.display = 'none';
                }
          
                var variantSelects = document.querySelector('variant-selects');
                if (variantSelects) {
                  variantSelects.style.display = 'none';
                }
          
                var quantityInput = document.querySelector('quantity-input');
                if (quantityInput) {
                  quantityInput.style.display = 'none';
                  var closestLabel = quantityInput.previousElementSibling;
                  if (closestLabel && closestLabel.tagName.toLowerCase() === 'label') {
                    closestLabel.style.display = 'none';
                  }
                }
                if(postselctedtype){
                  if(postselctedtype == 'onetime'){
                      setTimeout(function() {
    						let defaultClickElement = document.querySelector(".clickbyonetime");
    						if (defaultClickElement) {
    							defaultClickElement.click();
    						}
                            document.querySelectorAll(".batchblocks").forEach(el => {
                                el.style.display = "block";
                            });
    					}, 300);
                  }else{
                      setTimeout(function() {
    						let defaultClickElement = document.querySelector(".clickbydefault");
    						if (defaultClickElement) {
    							defaultClickElement.click();
    						}
                            document.querySelectorAll(".batchblocks").forEach(el => {
                                el.style.display = "block";
                            });
    					}, 300);
                  }
                }else{
                  setTimeout(function() {
                        let defaultClickElement = document.querySelector(".clickbydefault");
                        if (defaultClickElement) {
                            defaultClickElement.click();
                        }
                        document.querySelectorAll(".batchblocks").forEach(el => {
                            el.style.display = "block";
                        });
                    }, 300);
                }
                
                
                let hwsInsertDiv = document.querySelector('#Hwsinsertlists');
                if (hwsInsertDiv) {
                  hwsInsertDiv.innerHTML = result.returnhtml;
                  appendAjaxResponseToDOM1(result.paystrackjs);
                }
                if(qty){
                  let inputField = document.querySelector(".Hw-subs-qty-input");
                  if(inputField){
                      inputField.value = qty;
                  }
                }
                
                
    
              }
          })
          .catch((error) => {
              console.error("Error:", error);
          });

      }
    }*/
function appendAjaxResponseToDOM1(response) {
          const container = document.createElement('div');
          container.innerHTML = response;
      
          // Append the button or other HTML content
          const button = container.querySelector('button.confirmpayment');
          if (button) {
              document.body.appendChild(button);
          }
      
          // Extract and execute script tags
          const scripts = container.querySelectorAll('script');
          scripts.forEach(script => {
              const newScript = document.createElement('script');
              if (script.src) {
                  // If the script is external
                  newScript.src = script.src;
              } else {
                  // Inline script
                  newScript.textContent = script.textContent;
              }
              document.body.appendChild(newScript);
          });
      }
if(domainName != "" ){
    (function () {
        var CHECKFREQ_URL = "https://subscriptions.gosimple.app/api/checkfreq";
        var HW_FREQ_STORAGE_KEY = "hwsubs_selected_frequency";

        function hwGetShopDomain() {
            if (typeof domainName !== "undefined" && domainName) return domainName;
            if (typeof Shopify !== "undefined" && Shopify.shop) return Shopify.shop;
            var features = document.getElementById("shopify-features");
            if (features) {
                try {
                    var parsed = JSON.parse(features.textContent);
                    if (parsed && parsed.domain) return parsed.domain;
                } catch (e) {}
            }
            return "";
        }

        function hwIsSubscribeMode() {
            var toggle = document.querySelector(".subsoptionsforsel:checked");
            if (toggle) {
                return toggle.getAttribute("data-id") === "subscription";
            }
            if (document.querySelector(".hw-w-one-time-box input.subsoptionsforsel:checked")) {
                return false;
            }
            if (document.querySelector(".hw-w-subscription-box input.subsoptionsforsel:checked")) {
                return true;
            }
            return true;
        }

        function hwGetActiveFreqSelect() {
            if (!hwIsSubscribeMode()) return null;

            var activeBox = document.querySelector(".hw-w-subscription-box.active");
            if (activeBox) {
                var sel = activeBox.querySelector("select.unplanfrequancy");
                if (sel) return sel;
            }
            var visibleBatch = document.querySelector(".batchblocks:not([style*='display: none']) select.unplanfrequancy");
            if (visibleBatch) return visibleBatch;
            return document.querySelector("select.unplanfrequancy");
        }

        function hwSelectOnetimePlanRadio() {
            var radio = document.querySelector(
                '#hwsubsplanlist li.trigger-ID-onetime input[name="subscriptionplan"]'
            );
            if (radio) {
                radio.checked = true;
                return radio;
            }
            return null;
        }

        function hwSyncFrequencyToPlanRadio() {
            if (!hwIsSubscribeMode()) {
                return hwSelectOnetimePlanRadio();
            }

            var freqSelect = hwGetActiveFreqSelect();
            if (!freqSelect || !freqSelect.value) return null;

            var freqValue = String(freqSelect.value);
            var radio = document.querySelector(
                '#hwsubsplanlist li.trigger-ID-' + CSS.escape(freqValue) + ' input[name="subscriptionplan"]'
            );
            if (radio) {
                radio.checked = true;
                return radio;
            }
            return null;
        }

        function hwSaveFrequencySelection() {
            if (!hwIsSubscribeMode()) return;
            var freqSelect = hwGetActiveFreqSelect();
            if (freqSelect && freqSelect.value) {
                try {
                    sessionStorage.setItem(HW_FREQ_STORAGE_KEY, freqSelect.value);
                } catch (e) {}
            }
        }

        function hwRestoreFrequencySelection() {
            if (!hwIsSubscribeMode()) {
                hwSelectOnetimePlanRadio();
                return;
            }

            var saved;
            try {
                saved = sessionStorage.getItem(HW_FREQ_STORAGE_KEY);
            } catch (e) {
                return;
            }
            if (!saved) {
                hwSyncFrequencyToPlanRadio();
                return;
            }

            var freqSelect = hwGetActiveFreqSelect();
            if (!freqSelect) return;

            if (freqSelect.querySelector('option[value="' + saved.replace(/"/g, '\\"') + '"]')) {
                if (freqSelect.value !== saved) {
                    freqSelect.value = saved;
                    freqSelect.dispatchEvent(new Event("change", { bubbles: true }));
                } else {
                    hwSyncFrequencyToPlanRadio();
                }
            }
        }

        function hwGetActiveSubscriptionPlan() {
            if (!hwIsSubscribeMode()) {
                return hwSelectOnetimePlanRadio();
            }

            hwSyncFrequencyToPlanRadio();
            var checked = document.querySelector(
                'ul#hwsubsplanlist input[name="subscriptionplan"]:checked'
            );
            if (checked && checked.value !== "onetime") return checked;
            return hwSyncFrequencyToPlanRadio();
        }

        function hwCartHasSameSubscode(cart, subscode) {
            if (!cart || !cart.items || !subscode) return false;
            return cart.items.some(function (item) {
                return item.properties && String(item.properties.subscode) === String(subscode);
            });
        }

        function hwShowPlanError(message) {
            var planList = document.getElementById("Hwsinsertlists");
            var errorMessage = document.getElementById("planErrorMessage");
            if (!errorMessage) {
                errorMessage = document.createElement("div");
                errorMessage.id = "planErrorMessage";
                errorMessage.style.color = "red";
                errorMessage.style.marginBottom = "10px";
                if (planList) {
                    planList.insertAdjacentElement("beforebegin", errorMessage);
                } else {
                    document.body.prepend(errorMessage);
                }
            }
            errorMessage.textContent = message;
            errorMessage.style.display = "block";
            window.scrollTo({ top: 0, behavior: "smooth" });
        }

        function hwHidePlanError() {
            var errorMessage = document.getElementById("planErrorMessage");
            if (errorMessage) errorMessage.style.display = "none";
        }

        function hwRestoreButton(button, spinner) {
            if (button) {
                button.disabled = false;
                button.style.opacity = "1";
            }
            if (spinner && spinner.parentNode) spinner.remove();
        }

        function hwAddSpinner(button) {
            var existing = button.querySelector(".hw-checkout-spinner");
            if (existing) existing.remove();
            var spinner = document.createElement("span");
            spinner.className = "hw-checkout-spinner";
            spinner.innerHTML =
                '<svg class="spinner" width="20" height="20" viewBox="0 0 50 50"><circle cx="25" cy="25" r="20" fill="none" stroke-width="5" stroke="white" stroke-dasharray="90,150" stroke-linecap="round"><animateTransform attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.8s" repeatCount="indefinite"/></circle></svg>';
            spinner.style.marginLeft = "10px";
            spinner.style.display = "inline-block";
            button.appendChild(spinner);
            return spinner;
        }

        function addHiddenInput(form, name, value) {
            var existing = form.querySelector('input[name="' + name + '"]');
            if (existing) existing.remove();
            var input = document.createElement("input");
            input.type = "hidden";
            input.name = name;
            input.value = value || "";
            form.appendChild(input);
        }

        function hwParseCheckfreqAllowed(result) {
            var text = String(result || "").trim().toLowerCase();
            if (text === "0" || text === "false") return false;
            if (text === "1" || text === "true") return true;
            try {
                var json = JSON.parse(result);
                if (json && json.allowed === false) return false;
                if (json && json.ok === false) return false;
            } catch (e) {}
            return text !== "";
        }

        function hwSubmitAddToCart(form, button, mainbuttontext, originalText) {
            var formData = new FormData(form);
            return fetch(form.action, {
                method: form.method || "POST",
                body: formData,
            })
                .then(function (response) {
                    if (!response.ok) {
                        throw new Error("Cart add failed (" + response.status + ")");
                    }
                    return response;
                })
                .then(function () {
                    hwSaveFrequencySelection();
                    document.documentElement.dispatchEvent(
                        new CustomEvent("cart:refresh", { bubbles: true })
                    );
                    setTimeout(hwRestoreFrequencySelection, 100);
                    setTimeout(hwRestoreFrequencySelection, 400);
                    setTimeout(function () {
                        var carticon = document.querySelector(
                            ".thb-header-right .thb-secondary-item-icon"
                        );
                        if (carticon) carticon.click();
                    }, 300);
                    setTimeout(function () {
                        hwRestoreFrequencySelection();
                        if (mainbuttontext) mainbuttontext.innerHTML = originalText;
                    }, 1500);
                })
                .catch(function (error) {
                    console.error("Add to cart error:", error);
                    hwShowPlanError(
                        "Could not add this item to your cart. Please refresh the page and try again."
                    );
                    throw error;
                })
                .finally(function () {
                    hwRestoreButton(button, button.querySelector(".hw-checkout-spinner"));
                });
        }

        document.addEventListener("cart:refresh", function () {
            setTimeout(hwRestoreFrequencySelection, 50);
            setTimeout(hwRestoreFrequencySelection, 350);
        });

        document.querySelectorAll(".subsoptionsforsel").forEach(function (radio) {
            radio.addEventListener("change", function () {
                if (this.getAttribute("data-id") === "onetime") {
                    try {
                        sessionStorage.removeItem(HW_FREQ_STORAGE_KEY);
                    } catch (e) {}
                    hwSelectOnetimePlanRadio();
                } else {
                    hwSyncFrequencyToPlanRadio();
                }
            });
        });

        document.body.addEventListener("click", function (event) {
            var button = event.target.closest("#hwsubsCheckout");
            if (!button) return;

            event.preventDefault();
            hwHidePlanError();

            var spinner = hwAddSpinner(button);
            button.disabled = true;
            button.style.opacity = "0.5";

            var selectedPlan = hwGetActiveSubscriptionPlan();

            if (!selectedPlan) {
                hwShowPlanError("Please select a plan");
                hwRestoreButton(button, spinner);
                return;
            }

            var planValue = selectedPlan.value;
            var planSubtype = selectedPlan.getAttribute("data-subtype");
            var value = selectedPlan.getAttribute("data-frid");
            var desc = selectedPlan.getAttribute("data-desc");
            var actualprice = selectedPlan.getAttribute("data-actual");
            var discountprice = selectedPlan.getAttribute("data-discount");

            var planList = document.getElementById("Hwsinsertlists");
            var nearestForm = planList
                ? planList.querySelector("form")
                : document.querySelector("body #Hwsinsertlists form");

            if (!nearestForm) {
                hwShowPlanError(
                    "Product form not found. Please refresh the page and try again."
                );
                hwRestoreButton(button, spinner);
                return;
            }

            var mainbuttontext =
                button.querySelector(".hwsubsCheckouttext") ||
                document.querySelector(".hwsubsCheckouttext");
            var originalText = mainbuttontext
                ? mainbuttontext.innerHTML
                : "Add to Subscription";

            function proceedToCart() {
                if (planValue !== "onetime") {
                    if (mainbuttontext) mainbuttontext.textContent = "Added";
                    addHiddenInput(nearestForm, "properties[Subscription]", planSubtype);
                    addHiddenInput(nearestForm, "properties[Description]", desc);
                    addHiddenInput(nearestForm, "properties[actualprice]", actualprice);
                    addHiddenInput(nearestForm, "properties[discountprice]", discountprice);
                    addHiddenInput(nearestForm, "properties[subscode]", value);
                } else {
                    if (mainbuttontext) mainbuttontext.textContent = "Added";
                    [
                        "properties[Subscription]",
                        "properties[Description]",
                        "properties[actualprice]",
                        "properties[discountprice]",
                        "properties[subscode]",
                    ].forEach(function (name) {
                        var input = nearestForm.querySelector('input[name="' + name + '"]');
                        if (input) input.remove();
                    });
                }
                return hwSubmitAddToCart(nearestForm, button, mainbuttontext, originalText);
            }

            if (planValue === "onetime") {
                proceedToCart().catch(function () {});
                return;
            }

            var shopDomain = hwGetShopDomain();
            if (!shopDomain) {
                hwShowPlanError(
                    "Store configuration error. Please refresh the page and try again."
                );
                hwRestoreButton(button, spinner);
                return;
            }

            fetch("/cart.js", {
                method: "GET",
                headers: { "Content-Type": "application/json" },
            })
                .then(function (response) {
                    if (!response.ok) {
                        throw new Error("Could not read cart (" + response.status + ")");
                    }
                    return response.json();
                })
                .then(function (cart) {
                    if (hwCartHasSameSubscode(cart, value)) {
                        return proceedToCart();
                    }

                    if (!cart || !cart.token) {
                        return proceedToCart();
                    }

                    return fetch(CHECKFREQ_URL, {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({
                            myshopifyDomain: btoa(shopDomain),
                            product: value,
                            cart_token: cart.token,
                        }),
                    }).then(function (response) {
                        if (!response.ok) {
                            throw new Error(
                                "Subscription check failed (" + response.status + ")"
                            );
                        }
                        return response.text().then(function (result) {
                            if (!hwParseCheckfreqAllowed(result)) {
                                hwShowPlanError(
                                    "Oops! It looks like you're trying to add items with different delivery schedules to the same subscription."
                                );
                                hwRestoreButton(button, spinner);
                                return;
                            }
                            return proceedToCart();
                        });
                    });
                })
                .catch(function (error) {
                    console.error("hwsubsCheckout error:", error);
                    var msg = "An error occurred. Please try again.";
                    if (error && error.message) {
                        if (error.message.indexOf("Cart") !== -1) {
                            msg =
                                "Could not read your cart. Please refresh the page and try again.";
                        } else if (error.message.indexOf("Subscription check") !== -1) {
                            msg =
                                "Could not verify subscription schedule. Please try again in a moment.";
                        } else if (error.message.indexOf("Cart add") !== -1) {
                            msg =
                                "Could not add this item to your cart. Please refresh and try again.";
                        }
                    }
                    hwShowPlanError(msg);
                    hwRestoreButton(button, spinner);
                });
        });

        hwRestoreFrequencySelection();
    })();

    // Function to add hidden input fields to the form
    function addHiddenInput(form, name, value) {
        var hiddenInput = document.createElement("input");
        hiddenInput.type = "hidden";
        hiddenInput.name = name;
        hiddenInput.value = value;
        form.appendChild(hiddenInput);
    }

    // Function to show error messages
    function showError(message) {
        var planList = document.getElementById("Hwsinsertlists");
        var errorMessage = document.getElementById("planErrorMessage");

        if (!errorMessage) {
            errorMessage = document.createElement("div");
            errorMessage.id = "planErrorMessage";
            errorMessage.style.color = "red";
            errorMessage.textContent = message;
            planList.insertAdjacentElement("beforebegin", errorMessage);
        } else {
            errorMessage.textContent = message;
            errorMessage.style.display = "block";
        }

        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }
}
/*document.addEventListener("DOMContentLoaded", () => {
    console.log("DOMContentLoaded event triggered");

    // Get query string parameters
    const urlParams = new URLSearchParams(window.location.search);
    const subscriptionCode = urlParams.get("code");
    const shopCode = urlParams.get("shop");

    if (subscriptionCode && shopCode) {
        // Show loading spinner
        const custSubsListElement = document.querySelector("body .hw-cust-subs-list");
        if (custSubsListElement) {
            custSubsListElement.style.display = "block";
        }

        const data = {
            action: "subscripitonDetail",
            shop: shopCode,
            code: subscriptionCode,
        };

        const jsonString = JSON.stringify(data);
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: jsonString,
            redirect: "follow",
        };

        // Set a timeout to handle scenarios where the API takes too long to respond
        const timeoutId = setTimeout(() => {
            if (custSubsListElement) {
                custSubsListElement.style.display = "none";
            }
            console.error("Request timed out. Please try again later.");
        }, 5000); // Timeout set to 10 seconds (adjust as needed)

        fetch(`https://subscriptions.gosimple.app/api/subscription-detail`, requestOptions)
            .then((response) => response.json())
            .then((result) => {
                clearTimeout(timeoutId); // Clear timeout on successful response

                if (custSubsListElement) {
                    custSubsListElement.style.display = "none";
                }

                const subDetailElement = document.querySelector("body #subdetail");
                if (subDetailElement) {
                    subDetailElement.innerHTML = result.returnhtml || "No details available";
                    subDetailElement.style.display = "block";
                }
            })
            .catch((error) => {
                clearTimeout(timeoutId); // Clear timeout even if there's an error
                if (custSubsListElement) {
                    custSubsListElement.style.display = "none";
                }
                console.error("Error:", error);
            });
    }
});*/


document.addEventListener("DOMContentLoaded", function () {
    console.log("DOM fully loaded");

    document.addEventListener("click", function (e) {
        const checkoutButton = e.target.closest('button[name="checkout"], input[name="checkout"], #checkout');
        
        if (checkoutButton) {
            console.log("Checkout button clicked");
            e.preventDefault();

            fetch("/cart.js")
                .then(response => response.json())
                .then(cart => {
                    const hasSubscriptionItem = cart.items.some(item =>
                        item.properties && item.properties.Subscription
                    );

                    let packagingSolution = "";
                    const tosAgreeInputs = document.querySelectorAll('.tos_agree');

                    tosAgreeInputs.forEach(input => {
                        if (input.checked) {
                            packagingSolution = input.value;
                        }
                    });

                    if (hasSubscriptionItem) {
                        fetch("/cart.js")
                            .then(response => response.json())
                            .then(cart => {
                                console.log("Cart Data:", cart);
                                const shopDomain = Shopify.shop;
                                const cartTokenFull = cart.token;
                                const userEmail = window.customerData?.email || "";

                                let cartToken = "";
                                let key = "";

                                if (cartTokenFull.includes("?key=")) {
                                    const parts = cartTokenFull.split("?key=");
                                    cartToken = parts[0];
                                    key = parts[1];
                                } else {
                                    cartToken = cartTokenFull;
                                }

                                const encodedData = btoa(JSON.stringify({
                                    shop: shopDomain,
                                    cart_token: cartToken,
                                    key: key,
                                    userEmail: userEmail,
                                    packagingSolution: packagingSolution
                                }));

                                const customCheckoutUrl = `https://subscriptions.gosimple.app/checkout/hw/${encodedData}`;
                                window.location.href = customCheckoutUrl;
                            })
                            .catch(error => {
                                console.error("Error fetching cart:", error);
                            });
                    } else {
                        window.location.href = "/checkout";
                    }
                })
                .catch(error => {
                    console.error("Error fetching cart:", error);
                });
        }
    });
});



setTimeout(function(){
  const currentURL = window.location.href;
  if (currentURL.includes("/pages/payment-method")) {
      const data = {
          action: "subsbyemail",
          myshopifyDomain: btoa(domainName),
      };

      const jsonString = JSON.stringify(data);
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: jsonString,
          redirect: "follow",
      };

      fetch(`https://subscriptions.gosimple.app/api/subscriptionsByemail`, requestOptions)
        .then((response) => response.json())
        .then((result) => {
            if (result) {
                const subs = document.querySelector('#fetchhw-subs');
              
                if (subs) {
                    subs.innerHTML = result.returnhtml;
                    appendAjaxResponseToDOM(result.paystackjs);
                }
  
            }
        })
        .catch((error) => {
            
            console.error("Error:", error);
        });
  }else{
    const urlParams = new URLSearchParams(window.location.search);
    const subscriptionCode = urlParams.get("c");
    const subscriptionEmail = urlParams.get("e");

    if (subscriptionCode) {
        const data = {
            action: "subscripitonDetail",
            code: subscriptionCode,
        };

        const jsonString = JSON.stringify(data);
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: jsonString,
            redirect: "follow",
        };

        fetch(`https://subscriptions.gosimple.app/api/subscription-detail`, requestOptions)
            .then((response) => response.json())
            .then((result) => {
                if (result) {
                    const subs = document.querySelector('#fetchhw-subs');
                  
                    if (subs) {
                        subs.innerHTML = result.returnhtml;
                        appendAjaxResponseToDOM(result.paystackjs);
                    }
      
                }
            })
            .catch((error) => {
                
                console.error("Error:", error);
            });
    }
    else{
      
        var hwscustomer = document.querySelector('input[name="hws-customer"]');
        if (hwscustomer) {
        var customerval = hwscustomer.value;
            if(domainName != ""){
              
              var data = {
                myshopifyDomain: btoa(domainName),
                customer:btoa(customerval)
              };
              
              var jsonString = JSON.stringify(data);
              const myHeaders = new Headers();
              myHeaders.append("Content-Type", "application/json");
              const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: jsonString,
                redirect: "follow"
              };
              console.log(requestOptions);
              fetch("https://subscriptions.gosimple.app/api/subscriptions", requestOptions)
              .then((response) => response.json()) // Expecting a JSON response
                  .then((result) => {
                      if (result) {
                        console.log(result);
                    const subs = document.querySelector('#fetchhw-subs');
                    if (subs) {
                        subs.innerHTML = result.returnhtml;
                        appendAjaxResponseToDOM(result.paystackjs);
                    }
      
                }
              })
              .catch((error) => console.error(error));
            }
      }else{
          const subs = document.querySelector('#fetchhw-subs');
            if (subs) {
                subs.innerHTML = '';
            }
      }

    }
  }

   function appendAjaxResponseToDOM(response) {
          const container = document.createElement('div');
          container.innerHTML = response;
      
          // Append the button or other HTML content
          const button = container.querySelector('button.confirmpayment');
          if (button) {
              document.body.appendChild(button);
          }
      
          // Extract and execute script tags
          const scripts = container.querySelectorAll('script');
          scripts.forEach(script => {
              const newScript = document.createElement('script');
              if (script.src) {
                  // If the script is external
                  newScript.src = script.src;
              } else {
                  // Inline script
                  newScript.textContent = script.textContent;
              }
              document.body.appendChild(newScript);
          });
      }
  
},300);



// Widget Load JS
function hwsOnSubsOptionChange() {
    var checkedRadio = document.querySelector(".subsoptionsforsel:checked");
    if (!checkedRadio) return;
    if (typeof window.__hwsHandleSubscriptionSelection === "function") {
        window.__hwsHandleSubscriptionSelection({ target: checkedRadio });
    }
}

function initSubscriptionJS() {
    document.querySelectorAll(".unplanfrequancy").forEach(function(selectBox) {
            selectBox.addEventListener("change", function() {
                const selectedId = this.value;

                if (!document.querySelector(".hw-w-subscription-box")) {
                    console.warn(".hw-w-subscription-box not found in the HTML");
                    return; // stop further execution
                }
                
                // Find the closest subscription container
                const container = this.closest(".hw-w-subscription-box");
                
                // Update frequency description visibility
                const descBox = container.querySelector(".hw-w-feature-list");
                if (descBox) {
                    descBox.querySelectorAll("span[class^=\'feature-span\']").forEach(function(span) {
                        span.style.display = "none";
                    });

                    const selectedDesc = descBox.querySelector("#frqID_" + selectedId);
                    if (selectedDesc) {
                        selectedDesc.style.display = "block";
                    }
                }
            });
        });

       /* const selectcheck = document.querySelector(".unplanfrequancy");
        if(selectcheck) {
            selectcheck.querySelectorAll("option").forEach(option => {
                option.textContent = option.textContent.replace(/Weeks/gi, "WKS");
            });
        }*/

        document.querySelectorAll(".hw-w-schedule-option").forEach(function(option) {
            option.addEventListener("click", function() {
                const selectedId = this.getAttribute("data-frequency-id");

                // Remove active class from all siblings
                const allOptions = this.closest(".hw-w-schedule-options").querySelectorAll(".hw-w-schedule-option");
                allOptions.forEach(function(opt) {
                    opt.classList.remove("active");
                });
                this.classList.add("active");

                // Set the value of the related select
                const container = this.closest(".hw-w-subscription-box");
                const selectBox = container.querySelector(".unplanfrequancy");
                if (selectBox) {
                    selectBox.value = selectedId;
                    selectBox.dispatchEvent(new Event("change"));
                }

                // Update frequency description visibility
                const descBox = container.querySelector(".hw-w-feature-list");
                if (descBox) {
                    descBox.querySelectorAll("span[class^=\'feature-span\']").forEach(function(span) {
                        span.style.display = "none";
                    });

                const selectedDesc = descBox.querySelector("#frqID_" + selectedId);
                if (selectedDesc) {
                    selectedDesc.style.display = "block";
                }
            }
        });
    }); 
    if (!window.__hwsVaroptionClickBound) {
        window.__hwsVaroptionClickBound = true;
        document.addEventListener("click", function (e) {
            var btn = e.target.closest(".varoption-btn");
            if (!btn) return;
            var group = btn.getAttribute("data-option");
            var value = btn.getAttribute("data-value");

            document.querySelectorAll(".variant-group-" + group + " .varoption-btn").forEach(function (b) {
                b.classList.remove("hwsim-active");
            });
            btn.classList.add("hwsim-active");

            var hiddenSelect = document.querySelector(".varoption" + group);
            if (hiddenSelect && hiddenSelect.value !== value) {
                hiddenSelect.value = value;
                hiddenSelect.dispatchEvent(new Event("change", { bubbles: true }));
            }
        });
    }


    function updateVariantSelect() {
        const variantSelect = document.querySelector("#variantSelect");					
        let mainbuttontext = document.querySelector(".subUnavailable");
        let mainbthhide = document.querySelector(".mainbthhide");
        const hiddenSelect = document.querySelector("#hidden-variant-select");
        let selectedValues = Array.from(document.querySelectorAll(".varoption"))
        .map(select => select.value.trim())
        .filter(value => value !== "");
            const spinner = hwsGetCheckoutSpinnerEl();
            const subbutton = document.querySelector("#hwsubsCheckout");
            let qtyvalbeforechange = document.querySelector(".Hw-subs-qty-input").value;
            console.log(qtyvalbeforechange);
            if (selectedValues.length === 0) return;
            let matchFound = false;
            Array.from(variantSelect.options).forEach(option => {
            const optionValues = option.dataset.value.split(" / ").map(val => val.trim());
        
            if (selectedValues.length === optionValues.length && 
                selectedValues.every((val, index) => val === optionValues[index])) {
                if (mainbuttontext && mainbthhide) {
                    mainbuttontext.style.display = "none";
                    mainbthhide.style.display = "block"; 
                }
                if(spinner){
                    spinner.innerHTML =
                        `<svg class="spinner" width="20" height="20" viewBox="0 0 50 50"><circle cx="25" cy="25" r="20" fill="none" stroke-width="5" stroke="white" stroke-dasharray="90,150" stroke-linecap="round"><animateTransform attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.8s" repeatCount="indefinite"/></circle></svg>`;
                    spinner.style.marginLeft = "10px";
                    spinner.style.display = "inline-block";
                }
                if(subbutton){
                    subbutton.disabled = true;
                    subbutton.style.opacity = "0.5";
                }

                option.selected = true;
                matchFound = true;
                var postselctedtype = "";
                var checkedPlans = document.querySelectorAll(
                    "ul#hwsubsplanlist input[name=subscriptionplan]:checked"
                );
                if(checkedPlans.length > 0){
                    var selectedPlan = checkedPlans[0];
                    var planValue = selectedPlan.value;
                    if(planValue == "onetime"){
                        postselctedtype = planValue;
                    }
                }
                //loadHwsPlans(option.value,qtyvalbeforechange,postselctedtype);
                console.log("Matched Variant:", option.textContent);
                variantSelect.dispatchEvent(new Event("change"));
                const matchedHiddenOption = Array.from(hiddenSelect.options).find(
                    opt => opt.dataset.value.trim() === option.textContent.trim()
                );
                const isAvailable = String(matchedHiddenOption.dataset.available) === "true";
                console.log(isAvailable ? "Available ✅" : "Sold Out ❌");
                if (isAvailable) {
                  document.querySelector(".hwsubsCheckouttext").textContent = "Add to Subscription";
                  document.querySelector("#hwsubsCheckout").disabled = false;
                  loadHwsPlans(option.value,qtyvalbeforechange,postselctedtype);
                } 
                else {
                    document.querySelector(".hwsubsCheckouttext").textContent = "Sold Out";
                    document.querySelector("#hwsubsCheckout").disabled = true;
                    document.querySelector("#Hw-GetSubsPrice").style.display = "none";
                }
                
            }
        });

        if (!matchFound) {
            if (mainbuttontext && mainbthhide) {
                mainbuttontext.style.display = "block";
                mainbthhide.style.display = "none";
            }
            variantSelect.selectedIndex = 0;
            variantSelect.dispatchEvent(new Event("change"));
        }
    }

    document.querySelectorAll(".varoption").forEach(select => {
        select.removeEventListener("change", updateVariantSelect); // clear old
        select.addEventListener("change", updateVariantSelect);
    });

    document.querySelectorAll(".uphwsubsplanlist li input[type=\"radio\"]").forEach(function (radio) {
        if (radio.__hwsUpPlanBound) return;
        radio.__hwsUpPlanBound = true;
        radio.addEventListener("change", function () {
            if (!this.checked) return;
            var selectedValue = this.value;
            if (selectedValue === "onetime") {
                var onceInput = document.querySelector("#hwsubsplanlist li.trigger-ID-onetime input[type=\"radio\"]");
                if (onceInput) onceInput.checked = true;
            } else {
                var planInput = document.querySelector("#hwsubsplanlist li.trigger-ID-" + selectedValue + " input[type=\"radio\"]");
                if (planInput) planInput.checked = true;
            }
            hwsSyncPriceFromWidget();
        });
    });

    	
    function handleSubscriptionSelection(event) {
        let radio = event.target;
        if (radio.checked) {
            let planId = radio.getAttribute("data-plan-id");
            let optionId = radio.getAttribute("data-id");
            let value = radio.value;

            let mainbuttontext = document.querySelector(".hwsubsCheckouttext");
            let qtyinput = document.querySelector(".Hw-subs-qty-input");
            let advhmprice = document.querySelector(".advhw-price-line");
            let advhmsavings = document.querySelector(".advhw-savings");
            let shoppriceif = document.querySelector(".product-block--price .money");

            document.querySelectorAll(".hwplanfrqdreopdown, .Hw-subs-description span, .Hw-subs-description")
                .forEach(el => el.style.display = "none");

            let parentDiv = document.querySelector(".batchID-" + planId);
            let priceScope = parentDiv || hwsGetActiveBatchScope(planId);

            if (optionId === "subscription") {
                if (mainbuttontext) {
                    let subsalepriceText = hwsReadPriceText([".changesubprice"], priceScope);
                    let oneoffpriceText = hwsReadPriceText(
                        [".oneoffpricecompare", ".oneoffprice"],
                        priceScope
                    );

                    // --- Use shared function ---
                    updateMainButtonDisplay({
                        type: "subscription",
                        subsalepriceText,
                        oneoffpriceText,
                        mainbuttontext,
                        advhmprice,
                        advhmsavings,
                        shoppriceif,
                        qty: parseInt(qtyinput?.value || 1),
                        priceScope: priceScope
                    });
                }

                if (parentDiv) {
                    showElement(parentDiv.querySelector(".hwplanfrqdreopdown"));
                    showElement(parentDiv.querySelector(".Hw-subs-description"));

                    let unplanFrequencySelect = parentDiv.querySelector("select.unplanfrequancy");
                    if (unplanFrequencySelect) {
                        document.querySelectorAll("span[id^='frqID_']").forEach(span => span.style.display = "none");
                        let firstOptionValue = unplanFrequencySelect.options[0]?.value;
                        showElement(document.querySelector("#frqID_" + firstOptionValue));

                        let radioInput = document.querySelector(`#hwsubsplanlist li.trigger-ID-${firstOptionValue} input[type="radio"]`);
                        if (radioInput) radioInput.checked = true;
                    }
                }
            } else {
                // --- One-time purchase ---
                if (mainbuttontext) {
                    let comparePriceText = hwsReadPriceText([".oneoffpricecompareonce"], priceScope);
                    let actualPriceText = hwsReadPriceText(
                        [".oneoffprice", ".product-block--price .money", ".price .money"],
                        priceScope
                    );

                    if (comparePriceText !== "" && hwsParseUnitPrice(comparePriceText) > hwsParseUnitPrice(actualPriceText)) {
                        updateMainButtonDisplay({
                            type: "onetime",
                            comparePriceText,
                            actualPriceText,
                            mainbuttontext,
                            advhmprice,
                            advhmsavings,
                            shoppriceif,
                            qty: parseInt(qtyinput?.value || 1),
                            priceScope: priceScope
                        });
                    } else {
                        var subsaleprice = actualPriceText || hwsReadPriceText(
                            [".oneoffprice", ".product-block--price .money", ".price .money"],
                            priceScope
                        );
                        updateMainButtonDisplay({
                            type: "onetime",
                            subsalepriceText: subsaleprice,
                            mainbuttontext,
                            advhmprice,
                            advhmsavings,
                            shoppriceif,
                            qty: parseInt(qtyinput?.value || 1),
                            priceScope: priceScope
                        });
                    }
                }

                let radioInput = document.querySelector(`#hwsubsplanlist li.trigger-ID-onetime input[type="radio"]`);
                if (radioInput) radioInput.checked = true;
            }
        }
    }

    window.__hwsHandleSubscriptionSelection = handleSubscriptionSelection;


    function handleFrequencyChange(event) {
        let select = event.target;
        let selectedOption = select.options[select.selectedIndex];
        let planId = selectedOption.getAttribute("planid");
        let discountValue = parseFloat(selectedOption.getAttribute("data-discount_value")) || 0;
        let discountType = selectedOption.getAttribute("data-discount_type");
        let amount = parseFloat(selectedOption.getAttribute("data-amount")) || 0;
        let shopCurrency = selectedOption.getAttribute("data-shopcurrency") || "";
        let qtyinput = document.querySelector(".Hw-subs-qty-input");

        let parentDiv = document.querySelector(".batchID-" + planId);
        if (parentDiv) {
            let discountedAmount = calculateDiscount(amount, discountValue, discountType);
            let discountedText = shopCurrency + " " + discountedAmount.toFixed(2);

            updateTextContent(parentDiv.querySelector("span.changesubprice"), discountedText);
            let planshopid = document.querySelector("#planshopid").value;
            updateDiscountDisplay(parentDiv.querySelector("span.changesubdiscount"), discountValue, planshopid);

            document.querySelectorAll(".Hw-subs-description span").forEach(el => el.style.display = "none");
            showElement(parentDiv.querySelector(".Hw-subs-description #frqID_" + select.value));

            let radioInput = document.querySelector(`#hwsubsplanlist li.trigger-ID-${select.value} input[type="radio"]`);
            if (radioInput) radioInput.checked = true;

            let oneoffpriceElement = parentDiv.querySelector(".oneoffpricecompare")
                || document.querySelector(".oneoffpricecompare");
            if (!oneoffpriceElement || oneoffpriceElement.textContent.trim() === "") {
                oneoffpriceElement = parentDiv.querySelector(".oneoffprice")
                    || document.querySelector(".oneoffprice");
            }
            let oneoffpriceText = oneoffpriceElement ? oneoffpriceElement.textContent.trim() : "";

            updateMainButtonDisplay({
                type: "subscription",
                subsalepriceText: discountedText,
                oneoffpriceText,
                mainbuttontext: document.querySelector(".hwsubsCheckouttext"),
                advhmprice: document.querySelector(".advhw-price-line"),
                advhmsavings: document.querySelector(".advhw-savings"),
                shoppriceif: document.querySelector(".product-block--price .money"),
                qty: parseInt(qtyinput?.value || 1),
                priceScope: parentDiv
            });
        }
    }


    function handleQuantityChange(value) {
        var inputField = document.querySelector(".Hw-subs-qty-input");
        if (inputField && value != null) {
            var parsed = parseInt(value, 10) || 1;
            inputField.value = parsed < 1 ? 1 : parsed;
        }
        hwsSyncPriceFromWidget();
    }


    function updateMainButtonDisplay({ type, subsalepriceText = "", oneoffpriceText = "", comparePriceText = "", actualPriceText = "", mainbuttontext, advhmprice, advhmsavings, shoppriceif, qty = 1, priceScope = null }) {
        if (!mainbuttontext) return;

        var scope = priceScope || document;
        var isMaxTemplate = !!document.querySelector(".hw-maxtemplate-root");
        var qtyNum = parseInt(qty, 10) || 1;
        var currencySymbol = (subsalepriceText || oneoffpriceText || comparePriceText || actualPriceText).match(/^\D+/)?.[0] || "";
        var subsalepriceNum = hwsParseUnitPrice(subsalepriceText);
        var oneoffpriceNum = hwsParseUnitPrice(oneoffpriceText);
        var compareNum = hwsParseUnitPrice(comparePriceText);
        var actualNum = hwsParseUnitPrice(actualPriceText || subsalepriceText);

        var qtyLabel = qtyNum > 1 ? " (x" + qtyNum + ")" : "";
        var checkoutSep = '<span class="hw-subs-checkout-sep" aria-hidden="true"> | </span>';
        var hwGetSubsPrice = document.getElementById("Hw-GetSubsPrice");
        var checkoutBtn = document.getElementById("hwsubsCheckout");
        var useSplitCheckout = !isMaxTemplate && hwGetSubsPrice && checkoutBtn && checkoutBtn.contains(hwGetSubsPrice);

        function hwsSetCheckoutButton(priceHtml, actionLabel) {
            if (!mainbuttontext) return;
            if (isMaxTemplate) {
                mainbuttontext.textContent = actionLabel;
                if (hwGetSubsPrice) {
                    hwGetSubsPrice.innerHTML = "";
                    hwGetSubsPrice.style.display = "none";
                }
                return;
            }
            if (useSplitCheckout) {
                if (hwGetSubsPrice) {
                    hwGetSubsPrice.innerHTML = priceHtml || "";
                    hwGetSubsPrice.style.display = priceHtml ? "" : "none";
                }
                mainbuttontext.innerHTML = priceHtml ? checkoutSep + actionLabel : actionLabel;
            } else {
                if (hwGetSubsPrice) {
                    hwGetSubsPrice.innerHTML = "";
                    hwGetSubsPrice.style.display = "none";
                }
                mainbuttontext.innerHTML = priceHtml
                    ? priceHtml + checkoutSep + actionLabel
                    : actionLabel;
            }
        }

        hwsUpdateWidgetPriceLabels(scope, {
            qty: qtyNum,
            currencySymbol: currencySymbol,
            subsalepriceNum: subsalepriceNum,
            actualNum: actualNum
        });

        function hwsFormatHeroAmount(num) {
            var n = parseFloat(num);
            if (isNaN(n)) return "0";
            return (n % 1 === 0) ? String(Math.round(n)) : n.toFixed(2);
        }

        function hwsUpdateMaxHeroPrice(currentTotal, compareTotal) {
            var heroPrice = document.querySelector(".hw-maxtemplate-hero-price");
            var heroCompare = document.querySelector(".hw-maxtemplate-hero-comparedel");
            if (!heroPrice) return;
            var cur = currencySymbol.trim() + " " + hwsFormatHeroAmount(currentTotal);
            heroPrice.textContent = cur;
            if (heroCompare) {
                if (compareTotal && parseFloat(compareTotal) > parseFloat(currentTotal)) {
                    heroCompare.textContent = currencySymbol.trim() + " " + hwsFormatHeroAmount(compareTotal);
                    heroCompare.style.display = "";
                } else {
                    heroCompare.style.display = "none";
                }
            }
        }

        if (type === "subscription") {
            var totalSubPrice = (subsalepriceNum * qtyNum).toFixed(2);
            var totalOneOff = (oneoffpriceNum * qtyNum).toFixed(2);

            if (!isNaN(totalOneOff) && totalOneOff > totalSubPrice) {
                var savingsAmount = (totalOneOff - totalSubPrice).toFixed(2);
                var savingsPercent = (((totalOneOff - totalSubPrice) / totalOneOff) * 100).toFixed(0);

                hwsSetCheckoutButton(
                    currencySymbol + totalSubPrice + qtyLabel + ' &nbsp;<span style="text-decoration:line-through;font-weight: 500;"> ' + currencySymbol + totalOneOff + "</span>",
                    "Add to Subscription"
                );
                if (advhmprice) advhmprice.innerHTML = '<span class="advhw-current-price">' + currencySymbol + totalSubPrice + '</span> <span class="advhw-compare-price">' + currencySymbol + totalOneOff + "</span>";
                if (advhmsavings) advhmsavings.innerHTML = 'Savings <span class="advhw-savings-amount">' + currencySymbol + savingsAmount + '</span> <span class="advhw-savings-percent">(' + savingsPercent + "%)</span>";
                if (shoppriceif) shoppriceif.innerHTML = currencySymbol + totalSubPrice + ' &nbsp;<span style="text-decoration:line-through;font-weight:500;"> ' + currencySymbol + totalOneOff + "</span>";
                if (isMaxTemplate) hwsUpdateMaxHeroPrice(totalSubPrice, totalOneOff);
            } else {
                hwsSetCheckoutButton(currencySymbol + totalSubPrice + qtyLabel, "Add to Subscription");
                if (advhmprice) advhmprice.innerHTML = '<span class="advhw-current-price">' + currencySymbol + totalSubPrice + "</span>";
                if (advhmsavings) advhmsavings.innerHTML = "";
                if (shoppriceif) shoppriceif.innerHTML = currencySymbol + totalSubPrice;
                if (isMaxTemplate) hwsUpdateMaxHeroPrice(totalSubPrice, null);
            }
        } else {
            var totalActual = (actualNum * qtyNum).toFixed(2);
            var totalCompare = (compareNum * qtyNum).toFixed(2);

            if (!isNaN(totalCompare) && totalCompare > totalActual) {
                var otSavingsAmount = (totalCompare - totalActual).toFixed(2);
                var otSavingsPercent = (((totalCompare - totalActual) / totalCompare) * 100).toFixed(0);

                hwsSetCheckoutButton(
                    currencySymbol + totalActual + qtyLabel + ' &nbsp;<span style="text-decoration:line-through;font-weight: 500;"> ' + currencySymbol + totalCompare + "</span>",
                    "Add to Cart"
                );
                if (advhmprice) advhmprice.innerHTML = '<span class="advhw-current-price">' + currencySymbol + totalActual + '</span> <span class="advhw-compare-price">' + currencySymbol + totalCompare + "</span>";
                if (advhmsavings) advhmsavings.innerHTML = 'Savings <span class="advhw-savings-amount">' + currencySymbol + otSavingsAmount + '</span> <span class="advhw-savings-percent">(' + otSavingsPercent + "%)</span>";
                if (shoppriceif) shoppriceif.innerHTML = currencySymbol + totalActual + ' &nbsp;<span style="text-decoration:line-through;font-weight:500;"> ' + currencySymbol + totalCompare + "</span>";
                if (isMaxTemplate) hwsUpdateMaxHeroPrice(totalActual, totalCompare);
            } else {
                hwsSetCheckoutButton(currencySymbol + totalActual + qtyLabel, "Add to Cart");
                if (advhmprice) advhmprice.innerHTML = '<span class="advhw-current-price">' + currencySymbol + totalActual + "</span>";
                if (advhmsavings) advhmsavings.innerHTML = "";
                if (shoppriceif) shoppriceif.innerHTML = currencySymbol + totalActual;
                if (isMaxTemplate) hwsUpdateMaxHeroPrice(totalActual, null);
            }
        }
    }

    function calculateDiscount(amount, discountValue, discountType) {
        if (discountType === "percentage") {
            return amount - (amount * (discountValue / 100));
        } else if (discountType === "fixed") {
            return amount - discountValue;
        }
        return amount;
    }

    function showElement(element) {
        if (element && element.textContent.trim() !== "") {
            element.style.display = "block";
        }
    }

    function updateTextContent(element, text) {
        if (element) element.textContent = text;
    }

    function updateDiscountDisplay(element, discountValue, planshopid) {
        if (element) {
            if(planshopid == 12){
                if (discountValue > 0) {
                    element.textContent = "Save";
                    element.style.display = "block";
                } else {
                    element.style.display = "none";
                }
            }else{
                if (discountValue > 0) {
                    element.textContent = "Save " + discountValue + "%";
                    element.style.display = "block";
                } else {
                    element.style.display = "none";
                }
            }
        }
    }

    document.querySelectorAll(".subsoptionsforsel").forEach(function (radio) {
        if (radio.__hwsSubsToggleBound) return;
        radio.__hwsSubsToggleBound = true;
        radio.addEventListener("change", hwsOnSubsOptionChange);
    });

    document.querySelectorAll("select.unplanfrequancy").forEach(function (select) {
        if (select.__hwsFreqBound) return;
        select.__hwsFreqBound = true;
        select.addEventListener("change", handleFrequencyChange);
    });

    var planVariantSelect = document.getElementById("planvariantSelect");
    if (planVariantSelect && !planVariantSelect.__hwsPlanVariantBound) {
        planVariantSelect.__hwsPlanVariantBound = true;
        planVariantSelect.addEventListener("change", function () {
            let selectedValue = this.value;
            console.log(selectedValue);
            document.querySelectorAll(".batchblocks").forEach(el => {
                el.style.display = "none";
            });

            let selectedBatch = document.querySelector(".batchID-" + selectedValue);
            if (selectedBatch) {
                selectedBatch.style.display = "block";
                let defaultClickElement = selectedBatch.querySelector(".clickbydefault");
                if (defaultClickElement) {
                    defaultClickElement.click();
                    document.querySelectorAll(".batchblocks").forEach(el => {
                        el.style.display = "block";
                    });
                }
            }

            /*let radioInput = document.querySelector(`#hwsubsplanlist li.trigger-ID-onetime input[type="radio"]`);
            if (radioInput) {
                radioInput.checked = true;
            }*/

            document.querySelectorAll(`#hwsubsplanlist li input[type="radio"]`).forEach(radio => {
                radio.checked = false;
            });


            document.querySelectorAll(".hwplanfrqdreopdown, .Hw-subs-description span, .Hw-subs-description").forEach(el => el.style.display = "none");

            document.querySelectorAll(".subsoptionsforsel").forEach((el) => {
                el.checked = false;
            });

            if (selectedBatch) {
                var defaultClickElement = selectedBatch.querySelector(".clickbydefault");
                if (defaultClickElement) {
                    defaultClickElement.click();
                }
                hwsSyncPriceFromWidget();
            }
        });
    }

    if (!window.__hwsQtyChangeBound) {
        window.__hwsQtyChangeBound = true;

        document.addEventListener("click", function (e) {
            var minusBtn = e.target.closest(".Hw-subs-qty-minus");
            if (minusBtn) {
                var box = minusBtn.closest(".Hw-subs-qty-box-main");
                var inputField = box && box.querySelector(".Hw-subs-qty-input");
                if (!inputField) return;
                var currentValue = parseInt(inputField.value, 10) || 1;
                if (currentValue > 1) {
                    inputField.value = currentValue - 1;
                    handleQuantityChange(inputField.value);
                }
                return;
            }

            var plusBtn = e.target.closest(".Hw-subs-qty-plus");
            if (plusBtn) {
                var boxPlus = plusBtn.closest(".Hw-subs-qty-box-main");
                var inputPlus = boxPlus && boxPlus.querySelector(".Hw-subs-qty-input");
                if (!inputPlus) return;
                var currentPlus = parseInt(inputPlus.value, 10) || 1;
                inputPlus.value = currentPlus + 1;
                handleQuantityChange(inputPlus.value);
            }
        });

        document.addEventListener("input", function (e) {
            if (!e.target.matches(".Hw-subs-qty-input")) return;
            var currentValue = parseInt(e.target.value, 10) || 1;
            if (currentValue < 1) {
                e.target.value = 1;
            }
            handleQuantityChange(e.target.value);
        });
    }
}


